import React from "react";
import styled from "styled-components";
import Signature from "../assets/policy/signature.png";
import Seo from "../components/Seo";

const Page = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem 4rem;
  h2 { margin-top: 2rem; }
  li { margin-bottom: 0.5rem; }
`;

const SignatureBlock = styled.div`
  margin-top: 3rem;
  img { display: block; height: 5rem; max-width: 100%; object-fit: contain; margin-bottom: 0.25rem; }
  .sig-line { width: 16rem; max-width: 100%; border-top: 1px dotted #333; padding-top: 0.4rem; }
  p { margin: 0.1rem 0; }
`;

export default function FoodSafety() {
  return (
    <Page>
      <Seo
        title="Quality & Food Safety Policy | Keep IT Cool & Markiti"
        description="Keep IT Cool's Quality and Food Safety Policy: hygiene, temperature control, traceability and FSSC 22000 commitments."
        path="/food-safety"
      />
      <h1>Quality &amp; Food Safety Policy</h1>

      <h2>Commitment</h2>
      <p>
        Keep IT Cool Limited is committed to supplying safe, high quality food
        products. We do not compromise food safety for speed or cost, and
        Management will provide the leadership, resources and training needed
        to protect public health and keep our products safe and fresh. The
        management shall ensure the policy is communicated, understood and
        implemented by all its stakeholders.
      </p>

      <h2>Purpose</h2>
      <p>
        This policy sets out how Keep IT Cool sources, stores, handles and
        distributes food safely and in line with legal, regulatory and customer
        requirements. It applies to all employees and operations.
      </p>

      <h2>Objectives</h2>
      <ul>
        <li>Comply with all applicable food safety laws and customer specifications.</li>
        <li>Prevent contamination through strict hygiene, temperature control and traceability.</li>
        <li>Continually improve our Food Safety Management System (FSSC 22000).</li>
        <li>Establish emergency preparedness measures against food safety and quality hazards to guarantee operations continuity.</li>
        <li>Train employees to understand and apply their food safety responsibilities.</li>
        <li>Set annual food safety targets and verify results through audits. Maintain documented information ensuring adherence to the FSMS operations.</li>
      </ul>
      <p>
        Every employee is accountable for applying this policy and shall be
        reviewed annually.
      </p>

      <SignatureBlock>
        <img src={Signature} alt="Managing Director's signature" />
        <div className="sig-line">
          <p><strong>Approved by:</strong> Managing Director</p>
          <p><strong>Date:</strong> 23rd September 2026</p>
        </div>
      </SignatureBlock>
    </Page>
  );
}